import {
  type MerchantBase,
  MERCHANT,
  getMerchantsList,
} from '@/api/initial-state';

type MerchantsState = {
  merchants: MerchantBase[];
  activeMerchantId: MERCHANT | null;
};

export const useMerchantsStore = defineStore('merchants', {
  state(): MerchantsState {
    const merchants = getMerchantsList();

    return {
      merchants: markRaw(merchants),
      activeMerchantId: null,
    };
  },

  getters: {
    activeMerchant(state): MerchantBase | undefined {
      return state.merchants.find(
        (item) => item['item-id'] === state.activeMerchantId,
      );
    },
  },

  actions: {
    setActiveMerchant(id: MERCHANT | null) {
      this.activeMerchantId = id;
    },
  },
});
